// src/pages/Home/components/ChamadaFinalSection.js
//
// Ultimo bloco antes do rodape. Quem rolou a home inteira e chegou aqui ja
// demonstrou interesse; sair sem oferecer o proximo passo desperdicia isso.
//
// Duas acoes, nao uma: a home atende dois publicos com intencoes opostas
// (quem procura imovel e quem tem imovel), e um CTA unico sempre atende mal
// um dos dois. O contato por e-mail fica visivel em texto, nao escondido
// atras de formulario - pessoa que quer falar com gente desiste de
// formulario.
import React from 'react'
import { Box, Button, Link as MuiLink, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import Secao from '../../../components/Layout/Secao'
import { evento } from '../../../analytics'

const ChamadaFinalSection = () => (
  <Secao fundo='padrao' ritmo='padrao'>
    <Box sx={{ maxWidth: 680, marginRight: 'auto' }}>
      <Typography
        component='h2'
        sx={{ fontSize: { xs: '1.5rem', md: '1.9rem' }, fontWeight: 700, lineHeight: 1.25, mb: 1.5 }}
      >
        Tem um imóvel para vender ou alugar?
      </Typography>
      <Typography sx={{ color: 'text.secondary', fontSize: '1.02rem', lineHeight: 1.7, mb: 3 }}>
        Anunciar é gratuito e leva alguns minutos. Você não paga para publicar, não
        paga mensalidade e não paga comissão sobre o negócio fechado.
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 3 }}>
        <Button
          component={RouterLink}
          to='/dashboard/novo-imovel'
          variant='contained'
          size='large'
          onClick={() => evento('anunciar_clique', { origem: 'chamada_final' })}
        >
          Anunciar meu imóvel
        </Button>
        <Button component={RouterLink} to='/imoveis' variant='outlined' size='large'>
          Ver imóveis disponíveis
        </Button>
      </Box>

      <Typography sx={{ fontSize: '.92rem', color: 'text.secondary' }}>
        Dúvida antes de começar? Escreva para{' '}
        <MuiLink href='mailto:contato@umarkt.com.br' underline='hover'>
          contato@umarkt.com.br
        </MuiLink>
        .
      </Typography>
    </Box>
  </Secao>
)

export default ChamadaFinalSection
